<div class="container-fluid p-3 bg-white">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">

        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}
          </h4>

          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ proposalName }}]
          </h5>


        </div>
        <div>

          <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">

        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <!-- Firm Capacity Required -->
  <div class="bg-white rounded-md border border-slate-300 px-4 py-3 sm:px-6 sm:py-4 mb-4"
    *ngIf="schemeType =='rev' && stepDetails?.code === 'R-TEC'">
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

      <!-- Label -->
      <div>
        <h4 class="text-base sm:text-lg font-semibold text-slate-800">
          Firm Capacity Required
        </h4>
        <p class="text-sm text-slate-500">
          Please specify whether firm capacity is required for this proposal
        </p>
      </div>

      <!-- Radio Buttons -->
      <div class="flex items-center gap-6">

        <!-- YES -->
        <label class="flex items-center gap-2 cursor-pointer">
          <input type="radio" name="firmCapability" value="yes" [(ngModel)]="firmCapacityRequired"
            class="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" />
          <span class="text-sm font-medium text-slate-700">Yes</span>
        </label>

        <!-- NO -->
        <label class="flex items-center gap-2 cursor-pointer">
          <input type="radio" name="firmCapability" value="no" [(ngModel)]="firmCapacityRequired"
            class="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" />
          <span class="text-sm font-medium text-slate-700">No</span>
        </label>

      </div>

    </div>
  </div>

  <hr class="my-3" />

  <!-- R-TEC Specific Fields -->
  <div class="card shadow-sm border-0 p-4 mb-4" *ngIf="stepDetails?.code === 'R-TEC'">
    <h5 class="mb-3 text-primary">Meeting Details</h5>

    <!-- Row 1: Meeting Date & Time -->
    <div class="row g-3">
      <div class="col-md-6">
        <label for="meeting_date" class="form-label">Meeting Date</label>
        <input type="date" id="meeting_date" class="form-control" [(ngModel)]="meeting_date"
          [disabled]="!stepDetails?.can_edit" />
      </div>

      <div class="col-md-6">
        <label for="meeting_time" class="form-label">Meeting Time</label>
        <input type="time" id="meeting_time" class="form-control" [(ngModel)]="meeting_time"
          [disabled]="!stepDetails?.can_edit" />
      </div>
    </div>

    <!-- Row 2: TEC Approval Date -->
    <div class="row g-3 mt-0">
      <div class="col-md-6">
        <label for="tec_approval" class="form-label">TEC Approval Date</label>
        <input type="date" id="tec_approval" class="form-control" [(ngModel)]="tec_approval"
          [disabled]="!stepDetails?.can_edit" />
      </div>
      <div class="col-md-6">
        <label for="meeting_venue" class="form-label">Meeting Venue</label>
        <textarea id="meeting_venue" class="form-control" [(ngModel)]="meeting_venue" placeholder="Enter meeting venue"
          rows="3" [disabled]="!stepDetails?.can_edit"></textarea>
      </div>
    </div>

    <!-- Save Button -->
    <div class="row mt-3" *ngIf="stepDetails?.can_edit">
      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-primary" (click)="updateTecFields()">
          <i class="pi pi-save me-1"></i> Save Meeting Details
        </button>
      </div>
    </div>
  </div>

  <!-- Tender Opening Sheet Section (only for schemeType 'rev') -->
  <div class="mb-3" *ngIf="schemeType === 'rev' && stepDetails?.code === 'R-TO&RFP'">
    <p-accordion>
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="d-flex justify-content-between align-items-center px-2   rounded-top">
            <span class="fw-semibold text-dark small">Tender Opening Sheet</span>
          </div>
        </ng-template>

        <div class="mb-2 px-2 py-3 bg-slate-100 rounded-bottom shadow-inner">
          <div class="mb-2 d-flex gap-2" *ngIf="stepDetails?.can_edit">
            <button class="btn btn-xs btn-outline-primary" (click)="addTableRow()">
              <i class="pi pi-plus"></i> Add Row
            </button>
            <!-- <button class="btn btn-xs btn-primary" (click)="saveTenderSheet()">
              <i class="pi pi-save"></i> Save
            </button> -->
          </div>
          <div>
            <label class="form-label fw-bold text-blue-700 mb-1 small">Tender Opening Sheet</label>
            <editor [(ngModel)]="tenderSheetEditorData" [init]="init" [disabled]="!stepDetails?.can_edit"></editor>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>

  <p-accordion>
    <p-accordionTab *ngFor="let row of winners; let i = index">
      <ng-template pTemplate="header">
        <div class="d-flex justify-content-between align-items-center px-2  bg-slate-100 rounded-top">
          <span class="fw-semibold text-dark small">{{ row.vendor.name }}</span>
          <span *ngIf="row.vendor_status && format == 'upload'" class="ms-2 text-xs fw-medium" [ngClass]="{
              'text-success': row.vendor_status === 'Qualified' || row.vendor_status === 'Qualify',
              'text-danger': row.vendor_status === 'Disqualified' || row.vendor_status === 'Disqualify'
            }">
            ({{ row.vendor_status === 'Qualify' ? 'Qualified' : row.vendor_status === 'Disqualify' ? 'Disqualified' :
            row.vendor_status }})
          </span>
          <span class="d-flex gap-2 ms-2"
            *ngIf="format == 'upload' && stepDetails?.can_edit && showQualifyDisqualifyButtons">
            <button class="btn btn-xs btn-success px-2 py-0" (click)="setStatus(row, 'Qualify')">Qualify</button>
            <button class="btn btn-xs btn-danger px-2 py-0" (click)="setStatus(row, 'Disqualify')">Disqualify</button>
          </span>
        </div>
      </ng-template>
      <div class="mb-2 px-2  bg-white rounded-bottom shadow-inner">
        <app-vender-specfic-document [proposalStep]="stepDetails" [vendorId]="row.vendor.id"
          [isEdit]="stepDetails?.can_edit && format !== 'upload'" [url]="url">
        </app-vender-specfic-document>

        <!-- Remark field for disqualified vendors -->
        <div class="mt-2 mb-2" *ngIf="row.vendor_status === 'Disqualified'">
          <label class="form-label fw-semibold text-danger small">Remark</label>
          <div class="d-flex gap-2 align-items-center">
            <input type="text" class="form-control" [(ngModel)]="row.remark"
              placeholder="Enter remark for disqualification" [disabled]="!stepDetails?.can_edit" />
            <button *ngIf="stepDetails?.can_edit" class="btn btn-sm btn-danger" (click)="saveRemark(row)"
              [disabled]="!row.remark">
              <i class="pi pi-save me-1"></i>Save
            </button>
          </div>
        </div>
      </div>
    </p-accordionTab>
    <p-accordionTab *ngIf="stepDetails?.code =='R-TO&RFP'">
      <ng-template pTemplate="header">
        <div class="d-flex align-items-center px-2  rounded-top">
          <span class="fw-semibold text-dark small">Document Upload</span>
        </div>
      </ng-template>
      <app-upload-document [title]="'Upload Tender Opening Document'"
        [isEditable]="stepDetails.can_edit"></app-upload-document>
    </p-accordionTab>
  </p-accordion>

  <ng-container *ngIf="schemeType==='rev'">
        <app-upload-document [title]="'TEC MOM Upload Document'" [isEditable]="stepDetails.can_edit" `></app-upload-document>
      </ng-container>
</div>